export default {"src":"/_next/static/media/arrow-button-quiz-right.0cd6e76b.svg","height":14,"width":20,"blurWidth":0,"blurHeight":0};